import { render } from "./AuthorizedSignatoryDetails.vue?vue&type=template&id=12774d8e"
import script from "./AuthorizedSignatoryDetails.vue?vue&type=script&lang=js"
export * from "./AuthorizedSignatoryDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__